module.exports = __webpack_public_path__ + "img/sovcom.58e22121.png";